import { render } from "./DefaultFooter.vue?vue&type=template&id=1e4c6f0c&scoped=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=js"
export * from "./DefaultFooter.vue?vue&type=script&lang=js"

import "./DefaultFooter.scss?vue&type=style&index=0&id=1e4c6f0c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4c6f0c"]])

export default __exports__